import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Sidebar } from 'components/sidebar';

import { contentContainerSx, gradientContainerSx } from './styles';

interface IPageLayoutProps {
  withSideBar: boolean,
  isAuth: boolean
}

/**
 * Компонент обертка с фоном для приложения
 * @param props - Пропсы компонента
 * @param props.withSideBar - Наличие сайдбара
 * @param props.isAuth - Является ли это экранов атворизации
 */
export const PageLayout = ({ withSideBar, isAuth }:IPageLayoutProps) => {
  /** Рендер основного компонента */
  const renderContent = () => (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <Box minHeight='100vh'
           display='flex'
           sx={{
             maxWidth: '1440px',
             margin: isAuth ? '0 auto' : '0',
             width: '100%'
           }}
           justifyContent='flex-start'>
        {withSideBar && <Sidebar />}
        <Box sx={contentContainerSx}>
          <Box sx={gradientContainerSx} />
          <Outlet />
        </Box>
      </Box>
    </QueryParamProvider>
  );

  return renderContent();
};
